import React, { useState } from "react";
import Snackbar, { SnackbarCloseReason } from "@material-ui/core/Snackbar";
import { Typography } from "@cube3/cubicle/src/core/atoms/Typography";
import { makeCSS } from "@cube3/cubicle/src/utils/makeCSS";
import { useModalActions } from "../../Modals/modalActions";


/**Pop up message in mobile version 
 * that let the user know that their comment was saved.
 */

const useCSS = makeCSS(({ theme }) => {
  return {
    snackbarRoot: {
      backgroundColor: theme.color.background.neutral,
      boxShadow: `0px 0px 0px 2px rgba(255, 212, 35, 0.12)`,
      width: 150,
      borderRadius: theme.borderRadius.lg,
      margin: 'auto',
      top: theme.spacing[52]
    }
  }
}

);
export const ReviewLinkSavedCommentNotice = () => {

  const classes = useCSS();
  const [open, setOpen] = useState(true);

  const { previousModal } = useModalActions();

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      setOpen(false);
      previousModal();
      return;
    }
    setOpen(false);
    previousModal();
  };


  return (
    <Snackbar
      classes={{
        root: classes.snackbarRoot
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      open={open}
      autoHideDuration={1500}
      onClose={handleClose}
      message={
        <Typography>
          Comment Saved!
        </Typography>
      }
      transitionDuration={{ enter: 0, exit: 1 }}
    />
  )
}




